<template>
  <div class="log">
    <v-btn
      class="messagebtn accounts-generate-invoice-btn"
      title="Generate Invoice"
      flat
      target="_blank"
      @click.stop="generateInvoice()"
      :disabled="!jobIds.length"
      v-if="countInvoice != 0"
      prepend-icon
      color="white darken-1"
    >
      <v-icon>receipt</v-icon>
      <span>Generate Invoice ({{ countInvoice }})</span>
    </v-btn>
    <v-btn
      class="messagebtn accounts-generate-invoice-btn"
      @click.stop="dialog = true"
      title="Generate Invoice"
      flat
      target="_blank"
      @click="generateInvoice()"
      :disabled="!jobIds.length"
      v-else
      prepend-icon
      color="white darken-1"
    >
      <v-icon>receipt</v-icon>
      <span>Generate Invoice</span>
    </v-btn>

    <v-dialog
      v-model="dialog"
      persistent
      max-width="36rem"
      content-class="invoice-type-dialog"
    >
      <v-form ref="form">
        <v-card class="invoice-type-card">
          <header class="oms-modal-header">
            <div class="oms-modal-header__brand">
              <div class="oms-modal-header__badge" aria-hidden="true">
                <v-icon>receipt</v-icon>
              </div>
              <div class="oms-modal-header__copy">
                <h2 class="oms-modal-header__title">Select Invoice Type</h2>
              </div>
            </div>
            <v-btn
              class="oms-modal-header__close"
              icon
              aria-label="Close select invoice type"
              title="Close"
              @click.prevent="close()"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </header>
          <v-progress-linear
            indeterminate
            color="trukkin-theme darken-2"
            v-show="loading"
          ></v-progress-linear>
          <div class="invoice-type-body">
            <v-radio-group
              v-model="selected"
              mandatory
              hide-details
              class="invoice-type-group"
            >
              <p class="invoice-type-heading">Invoice per job</p>
              <v-radio
                label="Single Invoice: Job Basis"
                value="singleJobInvoice"
                class="invoice-type-option"
              ></v-radio>
              <v-radio
                label="Single Invoice: With Assignment details"
                value="singleJobInvoiceWithAllAssignment"
                class="invoice-type-option"
              ></v-radio>
              <p class="invoice-type-heading">One invoice for multiple jobs</p>
              <p v-if="jobIds.length == 1" class="invoice-type-note">
                Select two or more jobs to use these.
              </p>
              <v-radio
                label="Single Invoice For Multiple Jobs"
                value="multiJobInvoice"
                class="invoice-type-option"
                :disabled="jobIds.length == 1"
              ></v-radio>
              <v-radio
                label="Single Invoice For Multiple Jobs With Assignment Details"
                value="multiJobInvoiceWithAllAssignment"
                class="invoice-type-option"
                :disabled="jobIds.length == 1"
              ></v-radio>
              <v-radio
                label="Single Invoice For Multiple Jobs With Assignment Details (& Ref. No.)"
                value="multiJobInvoiceWithAllAssignmentAndCustRefNo"
                class="invoice-type-option"
                :disabled="jobIds.length == 1"
              ></v-radio>
            </v-radio-group>
          </div>
          <div class="invoice-type-actions">
            <v-btn
              class="messagebtn accounts-generate-invoice-btn"
              title="Generate Invoice"
              flat
              target="_blank"
              :disabled="!selected.length"
              @click="openAdvanceStep()"
              prepend-icon
              color="white darken-1"
            >
              <v-icon>receipt</v-icon>
              <span>Generate Invoice</span>
            </v-btn>
          </div>
        </v-card>
        <CustomerAdvanceListPopup
          v-model="advanceDialog"
          :rows="advanceRows"
          @confirm="onAdvancesConfirmed"
          @cancel="onAdvancesCancelled"
        />

        <InvoiceStartedDialog v-model="invoiceDialog" />
        <GenerateInvoiceDialog
          :open="bankDialog"
          v-model="bank"
          :banks="bankInfo"
          permission="generate-purchase-invoice"
          :loading="loading"
          @change="setCustomerValues"
          @cancel="closeBankInfo()"
          @confirm="generateMultipleInvoice()"
        />
      </v-form>
    </v-dialog>
    <v-snackbar
      :timeout="4000"
      bottom
      color="red darken-2"
      v-model="error"
      class="white--text"
      v-if="error"
      >{{ error }}</v-snackbar
    >
  </div>
</template>

<script>
import { StorageKeys } from "../../constants/constants";
import { EventBus } from "../../event-bus.js";
import CustomerAdvanceListPopup from "@/components/Common/CustomerAdvanceListPopup";
import { apiErrorMessage } from "@/utils/customerAdvance";
import GenerateInvoiceDialog from "@/components/Common/GenerateInvoiceDialog";
import InvoiceStartedDialog from "@/components/Common/InvoiceStartedDialog";
export default {
  components: { CustomerAdvanceListPopup, GenerateInvoiceDialog, InvoiceStartedDialog },
  data() {
    return {
      error: "",
      dialog: false,
      invoicingCity: "",
      invoicingCountry: "",
      bankInfo: [],
      bankName: [],
      bank: "",
      beneficiaryName: "",
      branchCode: "",
      ibanNo: "",
      swiftCode: "",
      accountNo: "",
      bankId: "",
      invoiceDialog: false,

      bankDialog: false,
      loading: false,

      selected: [],
      single: "",
      advanceDialog: false,
      customerAdvances: [],
    };
  },
  props: {
    jobIds: Array,
    /* The selected rows, for the per job customer advance step. */
    jobRows: {
      type: Array,
      default: () => [],
    },
    countInvoice: Number,
    selectedCustomerForInvoice: Object,
  },
  computed: {
    /* Customer advance is UAE only, every other working country keeps the
       flow it had before. */
    advanceRows() {
      return (this.jobRows || [])
        .filter((row) => row.workingCountry == "UAE")
        .map((row) => ({
          id: row.jobId,
          title: `Job ${row.jobId}`,
          subtitle: row.companyName || row.customer || "",
          currency: row.customerCurrency || "",
        }));
    },
  },
  methods: {
    close() {
      this.selected = [];
      this.loading = false;
      this.dialog = false;
      this.customerAdvances = [];
    },

    /* Type is chosen, so ask for the advances before the bank step. Every
       type takes the same per job amounts, whether it produces one invoice
       per job or a single combined one. */
    openAdvanceStep() {
      if (!this.advanceRows.length) {
        this.fetchBank();
        return;
      }
      this.advanceDialog = true;
    },

    onAdvancesConfirmed({ advances }) {
      this.customerAdvances = advances.map((entry) => ({
        jobId: entry.id,
        customerAdvance: entry.amount,
      }));
      this.fetchBank();
    },

    onAdvancesCancelled() {
      this.customerAdvances = [];
    },

    setCustomerValues(val) {
      var data = this.bankInfo.filter((v) => {
        if (v.value === val) return v;
      });

      (this.beneficiaryName = data[0].beneficiaryName),
        (this.branchCode = data[0].branchCode),
        (this.accountNo = data[0].accountNo),
        (this.ibanNo = data[0].ibanNo),
        (this.bankId = data[0].bankId),
        (this.swiftCode = data[0].swiftCode);
      // this.beneficiaryName = data[0].beneficiaryName;
    },
    fetchBank() {
      this.bankDialog = true;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        invoicingCity: {
          code: this.selectedCustomerForInvoice.invoicingCity,
        },
        invoicingCountry: {
          code: this.selectedCustomerForInvoice.invoicingCountry,
        },
      };
      let { apiUrl } = this.constants;
      this.axios.post(`${apiUrl}/accounts/getBankDetails`, body, config).then(
        (response) => {
          const { data = null } = response.data;
          /* Replace, never append, so reopening the bank step does not list
             every bank again. */
          this.bankInfo = data.map((element) => ({
            text: element.bankName,
            value: element._id,
            beneficiaryName: element.beneficiaryName,
            branchCode: element.branchCode,
            accountNo: element.accountNo,
            ibanNo: element.ibanNo,
            bankId: element._id,
            swiftCode: element.swiftCode,
          }));
        },
        (error) => {
          this.error = "Something went wrong. Please try again later!";
          this.loading = false;
        }
      );
    },

    generateInvoice() {
      if (!this.selectedCustomerForInvoice["invoiceDay"]) {
        this.$emit("customerInvoiceFailed", {
          ...this.selectedCustomerForInvoice,
        });
        return false;
      }
      this.dialog = true;
    },
    chooseBank() {
      this.bankDialog = true;
    },
    closeBankInfo() {
      this.bankDialog = false;
      this.bankInfo = [];
      this.bank = "";
      (this.beneficiaryName = ""),
        (this.branchCode = ""),
        (this.accountNo = ""),
        (this.ibanNo = ""),
        (this.bankId = ""),
        (this.swiftCode = "");
    },
    generateMultipleInvoice() {
      if (!this.selected.length) {
        this.loading = false;
        this.error = "Please select invoicing type !";
        return;
      }
      if (!this.bank) {
        this.loading = false;
        this.error = "Please choose bank before generating the invoice";
        return;
      }
      this.loading = true;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let body = {
        jobIds: this.$props.jobIds,
        invoiceType: this.selected.toString(),
        bankId: this.bankId,
      };
      /* Customer advance is UAE only, and only the jobs an amount was
         entered against are sent. */
      if (this.customerAdvances.length) {
        body.customerAdvances = this.customerAdvances;
      }
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      this.axios
        .post(
          `${this.constants.apiUrl}/accounts/generateMultiIncoice`,
          body,
          config
        )
        .then(
          (response) => {
            const { status, data } = response.data;
            this.close();
            this.closeBankInfo();
            this.invoiceDialog = true;
            this.loading = false;
            localStorage.removeItem("customerFilter");
            this.$emit("reset");
          },
          (error) => {
            this.loading = false;
            /* The 400s name the job and the limit, so show them as they are. */
            this.error = apiErrorMessage(
              error,
              "Something went wrong. Please try again later!"
            );
            localStorage.removeItem("customerFilter");
          }
        );
    },
  },
};
</script>
<style lang="scss">
.typebox {
  display: block !important;
  max-width: 100%;
  width: 100%;
  .boxborder {
    align-items: center !important;
    border-bottom: 1px solid lightgray;
    display: flex !important;
    margin-right: 0;
    max-width: 100%;
    min-height: 3.125rem;
    padding: 0.625rem 0 !important;
    position: relative;
    width: 100%;
  }
  .boxborder .v-input__control,
  .boxborder .v-input__slot {
    max-width: 100%;
    min-width: 0;
    width: 100%;
  }
  .boxborder .v-input__slot {
    align-items: center !important;
    display: flex !important;
  }
  .boxborder .v-label {
    flex: 1 1 auto;
    line-height: 1.35;
    min-width: 0;
    overflow-wrap: anywhere;
    padding-right: 1rem;
    text-align: left !important;
    white-space: normal;
    word-break: normal;
  }
  .boxborder .v-input--selection-controls__input {
    flex: 0 0 2rem;
    margin-left: auto;
    order: 2;
    position: static !important;
    right: auto !important;
  }
}
</style>

<style scoped>
.fonthead {
  font-size: 20px;
}
</style>
<style src="../../styles/invoice-type-dialog.css"></style>
